import { Activity, BookOpen, ClipboardList, FileSpreadsheet, FileText, Inbox, LayoutDashboard, type LucideIcon } from "lucide-react";

export type ProcurementModeMenuItem = {
  icon: LucideIcon;
  label: string;
  path: string;
  /** Empty = visible to every role that can enter Procurement mode. */
  roles: string[];
};

/**
 * Left-nav items when the portal is in Procurement mode.
 * Retail Handovers is retired from normal navigation; legacy URLs redirect into this workspace.
 */
export const procurementModeMenuItems: ProcurementModeMenuItem[] = [
  { icon: LayoutDashboard, label: "Dashboard", path: "/procurement", roles: [] },
  { icon: Activity, label: "Activity", path: "/admin/activity", roles: ["admin"] },
  /** proposals:read_all — Inventory/Procurement company-wide proposal view (read-only). */
  { icon: ClipboardList, label: "Proposals", path: "/sales/proposals", roles: [] },
  { icon: FileText, label: "Murho Documents", path: "/procurement/murho-documents", roles: [] },
  { icon: FileSpreadsheet, label: "Mass DO Upload", path: "/procurement/mass-do-upload", roles: ["admin", "inventory"] },
  { icon: Inbox, label: "Correspondence Inbox", path: "/procurement/correspondence", roles: [] },
  { icon: BookOpen, label: "User Guide", path: "/procurement/guide", roles: [] },
];
